export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2:
      return splitKey[1]

    case splitKey.length === 3:
      if (splitKey[2].length >= 5) return splitKey[2]
      else return splitKey[0]

    case splitKey.length === 5:
      if (splitKey[0] === 'TOP' && splitKey[2] === 'LOCATE') return `${splitKey[3]} - ${splitKey[4]}`
      if (splitKey[0] === 'TOP' && splitKey[2] === 'MATCH') return '1 ~ 10'
      return splitKey[3]
    default:
      return splitKey[3]
  }
}
